/**
 * Workspace Route - Main workspace view
 *
 * Shows all items in the workspace (tables, linked tables, folders).
 * Part of the Data Workspace OS feature set.
 */

import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePage } from '@/features/workspace';
import { workspaceSearchSchema } from '@/features/workspace/utils/workspaceSearchSchema';

export const Route = createFileRoute('/_authenticated/_withWorkspace/workspace/')({
  component: WorkspaceIndexPage,
  validateSearch: workspaceSearchSchema,
});

function WorkspaceIndexPage() {
  const search = Route.useSearch();

  // Data fetching is handled by useWorkspaceItems via TanStack Query
  // No manual fetch calls needed - queries auto-fetch on mount

  // Pass folderId={null} to show only root-level items
  return (
    <WorkspacePage
      folderId={null}
      searchParams={search}
    />
  );
}
